import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import Select from '../../../common/forms/select/Select';
import { CURRENCY_TYPE } from '../../../../config/constants';
import BusinessSelect from '../../../common/forms/select/BusinessSelect';
import BankSelect from '../../../common/forms/select/BankSelect';
import { enumToSelectOptions } from '../../../../utils/enum';

const normalizeTrim = (value) => {
  if (!value) return value;

  return value.trim();
};

export const BankAccountForm = ({ handleSubmit, loading, active }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Banco" required>
          <Field name="bankId" component={BankSelect} validate={[isRequired]} />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Número de Cuenta" required>
          <Field
            name="accountNumber"
            component={TextInput}
            type="text"
            placeholder="Número de Cuenta"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Número de Cuenta Interbancaria" required>
          <Field
            name="interbankNumber"
            component={TextInput}
            type="text"
            placeholder="Número de Cuenta Interbancaria"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Moneda" required>
          <Field
            name="currency"
            component={Select}
            options={enumToSelectOptions(CURRENCY_TYPE)}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Convenio/Recaudación">
          <Field
            name="receipt"
            component={TextInput}
            type="text"
            placeholder="Convenio/Recaudación"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="ID de Cuenta Externa">
          <Field
            name="externalAccountId"
            component={TextInput}
            type="text"
            placeholder="ID de Cuenta Externa"
            normalize={normalizeTrim}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Empresa" required>
          <Field
            name="businessId"
            component={BusinessSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tabla 3 SUNAT" required>
          <Field
            name="sunatTableCode"
            component={TextInput}
            type="text"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Codigo SYS">
          <Field name="sysCode" component={TextInput} type="text" />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Orden">
          <Field name="orderNumber" component={TextInput} type="text" />
        </FormItem>
      </FormGroup>
      {active && (
        <FormGroup row>
          <FormItem label="Estado">
            <Label>
              <Field name="active" component="input" type="checkbox" /> Activo
            </Label>
          </FormItem>
        </FormGroup>
      )}
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.BankAccount.getIn(['current', 'activity']).isEmpty(),
});

BankAccountForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  active: PropTypes.bool,
};

BankAccountForm.defaultProps = {
  loading: false,
  active: false,
};

const formComponent = reduxForm({
  form: 'BankAccountForm',
})(BankAccountForm);

export default connect(mapStateToProps)(formComponent);
